import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import useMyLatestSubscriptionV1 from './useMyLatestSubscriptionV1';
import { getIdTokenCookie } from '@chegg/utils';
import adaptAsyncHookToUseQueryApi from '../utils/adaptAsyncHookToUseQueryApi';
/**
 * New hook created for my latest subscription
 * Behind feature flag to toggle between legacy and v1 my latest subscription
 * @returns MyLatestSubscriptionsV1WithDates
 */
var useMyLatestSubscription = function useMyLatestSubscription(options, teamName, environment) {
  var skipAllQueries = (options === null || options === void 0 ? void 0 : options.skip) || !getIdTokenCookie();
  var v1Response = useMyLatestSubscriptionV1(_objectSpread(_objectSpread({}, options), {}, {
    skip: skipAllQueries
  }), teamName, environment);
  if (!getIdTokenCookie()) {
    return adaptAsyncHookToUseQueryApi({
      status: 'skipped'
    });
  }
  return adaptAsyncHookToUseQueryApi(v1Response);
};
export default useMyLatestSubscription;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useMyLatestSubscription.js
// module id = 4163
// module chunks = 11